<script lang="ts">
	import Twitter from 'assets/svg/twitter.svg?component';
	import Reddit from 'assets/svg/reddit.svg?component';
	import Github from 'assets/svg/github.svg?component';
	import Facebook from 'assets/svg/facebook.svg?component';
	import ExternalLink from 'assets/svg/externalLink.svg?component';
	import StatisticItem from './StatisticItem/StatisticItem.svelte';
	import type { ICoinDetails } from 'customTypes/coinDetails';
	import { _ } from 'utils/i18/i18n';

	export let data: ICoinDetails;
	export let dark: boolean;

	interface ITooltipTexts {
		marketCap: string;
		supply: string;
		volume: string;
		deluted: string;
	}

	export const textsForTooltip: ITooltipTexts = {
		marketCap: `${$_('coinDetailed.tooltips.marketCap')}`,
		supply: `${$_('coinDetailed.tooltips.supply')}`,
		volume: `${$_('coinDetailed.tooltips.volume')}`,
		deluted: `${$_('coinDetailed.tooltips.deluted')}`,
	};

	const processFacebookLink = (link) => {
		if (!link.startsWith('https://')) {
			link = `https://facebook.com/${link}`;
		}
		return link;
	};

	const processTwitterLink = (link) => {
		if (link.startsWith('twitter.com')) {
			link = `https://${link}`;
		} else if (!link.startsWith('https://')) {
			link = `https://twitter.com/${link}`;
		}
		return link;
	};
</script>

<div class="wrapper" class:dark>
	<div class="stat-currency">
		<StatisticItem
			{dark}
			data={data.stats.market_cap}
			text={`${data.stats.symbol} ${$_('general.marketCap')}`}
			format="currency"
			showTooltip
			tooltipText={textsForTooltip.marketCap}
			isHTML
		/>
		<StatisticItem
			{dark}
			data={data.stats['1d']?.volume || ''}
			text={`${data.stats.symbol} 24H ${$_('coinDetailed.tradingVolume')}`}
			format="currency"
			showTooltip
			tooltipText={textsForTooltip.volume}
		/>
		<StatisticItem
			{dark}
			data={data.stats.max_supply
				? Number(data.stats.max_supply) * Number(data.stats.price)
				: data.stats.market_cap}
			text={`${data.stats.symbol} ${$_('coinDetailed.dilutedMarketCap')}`}
			format="currency"
			showTooltip
			tooltipText={textsForTooltip.deluted}
			isHTML
		/>
	</div>
	<div class="stat-number">
		<StatisticItem
			{dark}
			data={data.stats.circulating_supply || ''}
			text={`${data.stats.symbol} ${$_('coinDetailed.circulatingSupply')}`}
			format="decimal"
			showTooltip
			tooltipText={textsForTooltip.supply}
			isRecalculating={false}
		/>
		<StatisticItem
			{dark}
			data={data.stats.max_supply ?? null}
			text={`${data.stats.symbol} ${$_('coinDetailed.totalSupply')}`}
			format="decimal"
			showTooltip={false}
			tooltipText={null}
			isRecalculating={false}
		/>
		<StatisticItem
			{dark}
			data={data.stats.high || ''}
			text={`${data.stats.symbol} ${$_('coinDetailed.allTimeHigh')}`}
			format="currency"
			showTooltip={false}
			tooltipText={null}
			isRecalculating={false}
			isFiatValueOnly={true}
		/>
	</div>

	<div class="contract center">
		{#if data.links.block_explorer_url}
			<p class="text-grey">{$_('coinDetailed.tokenContractInfo')}</p>
			<a
				href={data.links.block_explorer_url}
				target="blank"
				aria-label="Go to Explorer"
				rel="noopener noreferrer"
			>
				<ExternalLink class="social-icon center" width="12" height="12" />
			</a>
		{/if}
	</div>
	<div class="website-wrapper center">
		{#if data.links.website_url}
			<p class="text text-grey">{$_('coinDetailed.website')}</p>
			<a class="website-url" href={data.links.website_url} target="blank" rel="noopener noreferrer"
				>{data.links.website_url ? `${new URL(data.links.website_url).hostname}` : ''}</a
			>
		{/if}
	</div>
	<div class="socials-wrapper">
		{#if data.links.facebook_url}
			<a
				href={processFacebookLink(data.links.facebook_url)}
				class="social-item center"
				rel="noopener noreferrer"
				target="#"
			>
				<Facebook class="social-icon center" width="12" height="12" />
				<p class="social">Facebook</p>
			</a>
		{/if}
		{#if data.links.twitter_url}
			<a
				href={processTwitterLink(data.links.twitter_url)}
				class="social-item center"
				rel="noopener noreferrer"
				target="#"
			>
				<Twitter class="social-icon center" width="12" height="12" />
				<p class="social">Twitter</p>
			</a>
		{/if}

		{#if data.links.reddit_url}
			<a href={data.links.reddit_url} class="social-item center" rel="noopener noreferrer" target="#">
				<Reddit class="social-icon center" width="12" height="12" />
				<p class="social">Reddit</p>
			</a>
		{/if}
		{#if data.links.github_url}
			<a href={data.links.github_url} class="social-item center" rel="noopener noreferrer" target="#">
				<Github class="social-icon center" width="12" height="12" />
				<p class="social">Github</p>
			</a>
		{/if}
	</div>
</div>

<style lang="scss">
	@import 'marketStatistic';
</style>
